module.exports = __webpack_public_path__ + "order/img/paw_print.0909ba3c.png";